import DateFormat from 'format-datetime';
import Linq from 'linq';
import S from 'string';

function TimeFormat(date, format = null) {
  if (S(date).isEmpty()) {
    return "";
  }
  if (S(format).isEmpty()) {

    return S(date).replaceAll("T", " ").replaceAll("Z", "").substr(0, 19).s;
  }
  return "";
}

function Sleep(ms) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve();
    }, ms);
  })
  console.log('sleep');
}
/**
 * 拓扑图关系
 * @param {*} myId 
 * @param {*} pId 
 * @param {*} list 
 */
function GetEdges(myId, pId, list) {
  const dic = new Map();
  const dic_1 = new Map();
  var len = list.length;
  for (var i = 0; i < len; i++) {
    dic.set(list[i][myId], list[i]);
    if (dic_1.has(list[i][pId])) {
      dic_1.get(list[i][pId]).push(list[i]);
    } else {
      dic_1.set(list[i][pId], [list[i]]);
    }
  }
  var nodes = [];
  for (var i = 0; i < len; i++) {
    if (!dic.has(list[i][pId])) {
      nodes.push(list[i]);
    }
  }
  var toDo = [];
  var len_1 = nodes.length;
  for (var i = 0; i < len_1; i++) {
    toDo.push(nodes[i]);
  }
  let edges = [];
  while (toDo.length) {
    var node = toDo.shift(); // the parent node
    if (dic_1.has(node[myId])) {
      var ls = dic_1.get(node[myId]);
      if (ls.length > 0) {
        ls.forEach(item => {
          edges.push({
            source: node[myId].toString(),
            target: item[myId].toString()
          });
        });
      }
      // node.children = ls; //dic_1.get(node[myId]);
      for (var j = 0; j < ls.length; j++) toDo.push(ls[j]);
    }
  }
  return edges; //树形菜单
};

function FormatHtml(strHtml) {
  if (!strHtml) {
    return '';
  }
  strHtml = splitLabel(strHtml, "SPAN");
  strHtml = splitLabel(strHtml, "P");
  strHtml = splitLabel(strHtml, "B");
  strHtml = splitLabel(strHtml, "FONT");
  strHtml = splitLabel(strHtml, "TABLE");
  strHtml = splitLabel(strHtml, "TD");
  strHtml = splitLabel(strHtml, "TR");
  //去除class
  strHtml = strHtml.replace(/\sclass=\w+?\b/g, "");
  //去除<o:p>
  strHtml = strHtml.replace(/<o:p>(.*?)<\/o:p>/ig, "$1");
  //去除<?xml.../>
  strHtml = strHtml.replace(/<\?xml.*?\/>/ig, "");
  //去除lang
  strHtml = strHtml.replace(/lang=\w+-\w+?\b/g, "");
  //去除face
  strHtml = strHtml.replace(/face=.+?>/g, ">");
  //去除vAlign
  strHtml = strHtml.replace(/vAlign=\w+?\b/ig, "");
  //去掉<st1:>
  strHtml = strHtml.replace(/<st1:chsdate.*?>(.*?)<\/st1:chsdate>/ig, "$1");
  //去掉多余的空格
  strHtml = strHtml.replace(/<(\w+?)\s+?>/ig, "<$1>");
  //去掉<o:lock v:ext="edit" aspectratio="t"></o:lock>此类代码
  strHtml = strHtml.replace(/<o:.+?<\/o:\w+?>/ig, "");
  //去掉<v:> <\v:>
  strHtml = strHtml.replace(/<v:.+?>/g, "");
  strHtml = strHtml.replace(/<\/v:.+?>/g, "");
  //设置border=1
  strHtml = strHtml.replace(/border=[0-9]/ig, "border=1");
  //如果td或table里同时有style="width:.." 和width=21去掉style="width:.."
  strHtml = strHtml.replace(/<td(.+?)style=\"width:.+?\"(.+?)width=(.+?)>/ig, "<td$1$2width=$3>");
  strHtml = strHtml.replace(/<table(.+?)style=\"width:\s.+?\"(.+?)width=(.+?)>/ig, "<table$1$2width=$3>");
  //去除size=+0
  strHtml = strHtml.replace(/size=\+\d/ig, "");
  //多个空格合并一个空格
  strHtml = strHtml.replace(/\s{2,}/g, " ");
  return strHtml;
}
//用<flag 分割字符串
function splitLabel(strHtml, flag) {
  var arr = strHtml.split("<" + flag + " ");
  var strLabel = arr[0];
  for (var i = 1; i < arr.length; i++) {
    var temp = splitStyle(arr[i]);
    strLabel = strLabel + "<" + flag + " " + temp;
  }
  return strLabel;
}
//分割style
function splitStyle(strStyle) {
  var regStyle = /^style=/i;
  if (!regStyle.test(strStyle)) return strStyle;
  var arrStyle = strStyle.split("\"");
  if (arrStyle.length > 1) {
    var strStyleRtn = splitChild(arrStyle[1]);
    //alert(strStyleRtn);
    //标记
    var tag = strStyleRtn;
    if (tag != "") {
      strStyleRtn = arrStyle[0] + "\"" + strStyleRtn;
    }
    for (var i = 2; i < arrStyle.length; i++) {

      strStyleRtn = strStyleRtn + "\"" + arrStyle[i];
    }
    if (tag == "") {
      strStyleRtn = strStyleRtn.substr(1, strStyleRtn.length - 1);
    }
    return strStyleRtn;
  } else {
    return strStyle;
  }

}
//把style中的每个属性都分割出来
function splitChild(strChild) {
  var regChild = /;/;
  //如果符合regChild则说明style里含有多个属性
  if (regChild.test(strChild)) {
    var arrChild = strChild.split("; ");
    var strRtn = "";
    var strColor = "";
    var strFontSize = "";
    var strFontWeight = "";
    var strWidth = "";
    for (var i = 0; i < arrChild.length; i++) {
      var regColor = /^COLOR:/i;
      if (regColor.test(arrChild[i])) {
        strColor = arrChild[i];
      }
      var regFontSize = /^FONT-SIZE:/i;
      if (regFontSize.test(arrChild[i])) {
        strFontSize = arrChild[i];
      }
      var regFontWeight = /^FONT-WEIGHT:/i;
      if (regFontWeight.test(arrChild[i])) {
        strFontWeight = arrChild[i];
      }
      var regWidht = /^WIDTH:/i;
      if (regWidht.test(arrChild[i])) {
        strWidth = arrChild[i];
      }
    }

    if (strColor != "") {
      strRtn = strRtn + strColor + ";";
    }
    if (strFontSize != "") {
      strRtn = strRtn + strFontSize + ";";
    }
    if (strFontWeight != "") {
      strRtn = strRtn + strFontWeight + ";";
    }
    if (strWidth != "") {
      strRtn = strRtn + strWidth + ";";
    }
    return strRtn;
  } else {
    var strRtn = "";
    var regColor = /^COLOR:/i;
    var regFontSize = /^FONT-SIZE:/i;
    var regFontWeight = /^FONT-WEIGHT:/i;
    var regWidth = /^WIDTH:/i;
    if (regColor.test(strChild)) {
      strRtn = strChild;
    }
    if (regFontSize.test(strChild)) {
      strRtn = strChild;
    }
    if (regFontWeight.test(strChild)) {
      strRtn = strChild;
    }
    if (regWidth.test(strChild)) {
      strRtn = strChild;
    }
    return strRtn;
  }
}
/**
 * 名字取最后2个字
 */
function nameLastTwo(name) {
  if (name) {
    if (name.length > 2) {
      if (name.indexOf('(群主)') > -1) {
        name = name.replace("(群主)", '')
      }
      if (name.indexOf("(") > -1) {
        name = name.substring(0, name.indexOf("("))
      }
      if (name.indexOf("（") > -1) {
        name = name.substring(0, name.indexOf("（"))
      }
      return name.substring(name.length - 2, name.length)
    } else {
      return name
    }
  } else {
    return ''
  }
}

export const File_Type = {
  image: ['.png', '.jpg', '.jpeg', '.gif', '.bmp'],
  video: ['.mp4', '.rmvb', '.mkv', '.wmv', '.flv'],
  document: ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.pdf', '.txt', '.tif', '.tiff'],
  getAll() {
    return [...this.image, ...this.video, ...this.document]
  },
};
/*
 * remote
 * 远程
 */
function remote(Ip, Mac, PId, sysUser, pws) {
  let url = "RedCoral://Remote/?Ip=" + Ip + "&Mac=" + Mac + "&PId=0" + "&sysUser=" + sysUser + "&pws=" + pws
  //console.log(url,'cesgi1')
  window.open(url, '_parent')
}

function isInnerIPFn() {
  // 获取当前页面url
  var curPageUrl = window.location.href;
  console.log('curPageUrl-0  ' + curPageUrl);

  var reg1 = /(http|ftp|https|www):\/\//g; //去掉前缀
  curPageUrl = curPageUrl.replace(reg1, '');
  // console.log('curPageUrl-1  '+curPageUrl);

  var reg2 = /\:+/g; //替换冒号为一点
  curPageUrl = curPageUrl.replace(reg2, '.');
  // console.log('curPageUrl-2  '+curPageUrl);

  curPageUrl = curPageUrl.split('.'); //通过一点来划分数组
  console.log(curPageUrl);


  var ipAddress = curPageUrl[0] + '.' + curPageUrl[1] + '.' + curPageUrl[2] + '.' + curPageUrl[3];

  var isInnerIp = false; //默认给定IP不是内网IP
  var ipNum = getIpNum(ipAddress);
  /**
   * 私有IP：A类  10.0.0.0    -10.255.255.255
   *       B类  172.16.0.0  -172.31.255.255
   *       C类  192.168.0.0 -192.168.255.255
   *       D类   127.0.0.0   -127.255.255.255(环回地址)
   **/
  var aBegin = getIpNum("10.0.0.0");
  var aEnd = getIpNum("10.255.255.255");
  var bBegin = getIpNum("172.16.0.0");
  var bEnd = getIpNum("172.31.255.255");
  var cBegin = getIpNum("192.168.0.0");
  var cEnd = getIpNum("192.168.255.255");
  var dBegin = getIpNum("127.0.0.0");
  var dEnd = getIpNum("127.255.255.255");
  isInnerIp = isInner(ipNum, aBegin, aEnd) || isInner(ipNum, bBegin, bEnd) || isInner(ipNum, cBegin, cEnd) || isInner(ipNum, dBegin, dEnd);
  return isInnerIp;
}

function getIpNum(ipAddress) {
  /*获取IP数*/
  var ip = ipAddress.split(".");
  var a = parseInt(ip[0]);
  var b = parseInt(ip[1]);
  var c = parseInt(ip[2]);
  var d = parseInt(ip[3]);
  var ipNum = a * 256 * 256 * 256 + b * 256 * 256 + c * 256 + d;
  return ipNum;
}

function isInner(userIp, begin, end) {
  return (userIp >= begin) && (userIp <= end);
}

//阿拉伯数字转中文数字
function NoToChinese(num) {
  if (!/^\d*(\.\d*)?$/.test(num)) {
    alert("Number is wrong!");
    return "Number is wrong!";
  }
  var AA = new Array("零", "一", "二", "三", "四", "五", "六", "七", "八", "九");
  var BB = new Array("", "十", "百", "千", "万", "亿", "点", "");
  var a = ("" + num).replace(/(^0*)/g, "").split("."),
    k = 0,
    re = "";
  for (var i = a[0].length - 1; i >= 0; i--) {
    switch (k) {
      case 0:
        re = BB[7] + re;
        break;
      case 4:
        if (!new RegExp("0{4}\\d{" + (a[0].length - i - 1) + "}$").test(a[0]))
          re = BB[4] + re;
        break;
      case 8:
        re = BB[5] + re;
        BB[7] = BB[5];
        k = 0;
        break;
    }
    if (k % 4 == 2 && a[0].charAt(i + 2) != 0 && a[0].charAt(i + 1) == 0) re = AA[0] + re;
    if (a[0].charAt(i) != 0) re = AA[a[0].charAt(i)] + BB[k % 4] + re;
    k++;
  }
  if (a.length > 1) //加上小数部分(如果有小数部分) 
  {
    re += BB[6];
    for (var i = 0; i < a[1].length; i++) re += AA[a[1].charAt(i)];
  }
  return re;
};

/**
 * 将list装换成tree
 * @param {Object} myId 数据主键id
 * @param {Object} pId  数据关联的父级id
 * @param {Object} list list集合
 */
function listToTree(myId, pId, list) { //将数组转化为树形结构
  const dic = new Map();
  const dic_1 = new Map();
  var len = list.length;
  for (var i = 0; i < len; i++) {
    dic.set(list[i][myId], list[i]);
    if (dic_1.has(list[i][pId])) {
      dic_1.get(list[i][pId]).push(list[i]);
    } else {
      dic_1.set(list[i][pId], [list[i]]);
    }
  }
  var nodes = [];
  for (var i = 0; i < len; i++) {
    if (!dic.has(list[i][pId])) {
      nodes.push(list[i]); //根节点
    }
  }
  var toDo = [];
  var len_1 = nodes.length;
  for (var i = 0; i < len_1; i++) {
    toDo.push(nodes[i]);
  };
  while (toDo.length) {
    var node = toDo.shift(); // the parent node
    if (dic_1.has(node[myId])) {
      var ls = dic_1.get(node[myId]);
      node.children = ls; //dic_1.get(node[myId]);
      for (var j = 0; j < ls.length; j++)
        toDo.push(ls[j]);
    }
  }
  return nodes; //树形菜单
};

function ckeckNumber(value) { //全数字
  if (S(value).isEmpty())
      return false;
  var reg = /^[0-9]*$/;
  return reg.test(value);
}

export {
  Linq,
  S,
  DateFormat,
  TimeFormat,
  Sleep,
  GetEdges,
  FormatHtml,
  nameLastTwo,
  remote,
  isInnerIPFn,
  NoToChinese,
  listToTree,
  ckeckNumber
};
